import type { Person } from '../../types'
import type { InstructorSummary } from '../pages/Dasboard/_components/types'

const formatExperienceType = (experienceType?: string[] | string) =>
  Array.isArray(experienceType)
    ? experienceType.filter(Boolean).join(' - ')
    : experienceType || ''

export const toInstructorSummary = (professor: Person): InstructorSummary => {
  const fullName = [professor.name, professor.lastname]
    .filter(Boolean)
    .join(' ')
  const routeName = `${professor.name}-${professor.lastname}`.toLowerCase()

  return {
    id: professor.uid,
    name: fullName,
    description: formatExperienceType(professor.experienceType),
    image: professor.image || '/assets/profile.png',
    profilePath: `/profesor/${encodeURIComponent(routeName)}`,
    classTypes: professor.activities ?? [],
  }
}
